import React from 'react';
import { DataContext } from '../App';

function TotalDetections() {
    const data = React.useContext(DataContext);

    const totalDetections = data.historical_total_detections;
    
    return (
        <div className="card-body d-flex align-items-center justify-content-center">
            <div className="d-flex align-items-center justify-content-center">
                <h1 className="text-black font-weight-bold text-center mb-0">
                    {totalDetections}
                </h1>
            </div>
        </div>
    );
}

export default TotalDetections;